import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export abstract class Repository {
  constructor(protected http: HttpClient) {

  }
}